(function () {
  const initHero = () => {
    const isRTL = getComputedStyle(document.body).direction === "rtl";

    const sections = document.querySelectorAll(
      ".hero-section:not(.hero_initialized)"
    );

    if (!sections.length) return;

    sections.forEach((section) => {
      const mediaWrapper = section.querySelector(".hero_image-wrapper");
      const content = section.querySelector(".hero_content-wrapper");
      const line = section.querySelector(".hero_line");
      const ticker = section.querySelector(".hero_ticker-wrapper");
      const tickerBlock = section.querySelector(".hero_ticker-block");
      const tickerText = ticker
        ? ticker.querySelector(".hero_ticker-text")
        : null;
      const tickerBox = section.querySelector(".hero_ticker-box");

      const isInViewport = (el) => {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom >= 0;
      };

      const calculateTransition = (word) => {
        const wordLength = word.textContent.trim().length;
        const baseDuration = 1500;
        const totalDuration = baseDuration + wordLength * 50;
        const cubicBezier = "cubic-bezier(.23, 1, .32, 1)";

        return {
          duration: `${totalDuration}ms`,
          easing: cubicBezier,
        };
      };

      // Reveal ticker words with staggered transitions
      const revealWords = (tickerRoot) => {
        if (!tickerRoot) return;

        const allTickers = tickerRoot.querySelectorAll(".hero_ticker-text");
        if (!allTickers.length) return;

        let delayOffset = 0;

        allTickers.forEach((currentTicker) => {
          const wordElements = currentTicker.querySelectorAll(".ticker-word");

          wordElements.forEach((word, wordIndex) => {
            const { duration, easing } = calculateTransition(word);

            setTimeout(() => {
              word.style.transition = `transform ${duration} ${easing}`;
              word.classList.add("visible");
            }, delayOffset + wordIndex * 100);
          });

          delayOffset += wordElements.length * 100;
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const target = entry.target;

            // Line: delay before expanding
            if (target.classList.contains("hero_line")) {
              setTimeout(() => {
                target.classList.add("visible");
              }, 500);
            } else {
              target.classList.add("visible");
            }

            // Trigger ticker word reveal when ticker comes into view
            if (tickerBlock && target === tickerBlock) {
              revealWords(ticker);
            }

            observer.unobserve(target);
          });
        },
        { threshold: 0.01 }
      );

      // Observe content, line, ticker block for entrance animations
      [content, line, tickerBlock].forEach((element) => {
        if (element) {
          observer.observe(element);
        }
      });

      // MEDIA (image / video) handling
      if (mediaWrapper) {
        const image = mediaWrapper.querySelector("img");
        const video = mediaWrapper.querySelector("video");

        let mediaLoadedCount = 0;
        let totalMedia = 0;

        if (image) {
          totalMedia += 1;
          imagesLoaded(image, function () {
            mediaLoadedCount++;
            if (mediaLoadedCount === totalMedia) {
              image.classList.add("hero_media_loaded");
            }
          });
        }

        if (video) {
          totalMedia += 1;

          const markLoaded = () => {
            mediaLoadedCount++;
            video.classList.add("hero_media_loaded");
          };

          if (video.readyState >= 3) {
            markLoaded();
          } else {
            video.addEventListener("loadeddata", markLoaded, { once: true });
          }
        }

        if (totalMedia > 0) {
          observer.observe(mediaWrapper);
        }
      }

      // TICKER setup
      if (ticker && tickerText) {
        const originalText = tickerText.textContent
          .trim()
          .replace(/\s+/g, " ");
        const words = originalText.split(" ");

        tickerText.innerHTML = "";
        words.forEach((word) => {
          const wordElement = document.createElement("span");
          wordElement.classList.add("ticker-word");
          wordElement.textContent = word + " ";
          tickerText.appendChild(wordElement);
        });

        const screenWidth = 2 * window.innerWidth;
        let tickerWidth = tickerText.offsetWidth;
        let numberOfClones = Math.max(3, Math.ceil(screenWidth / tickerWidth));

        for (let i = 0; i < numberOfClones; i++) {
          const tickerClone = tickerText.cloneNode(true);
          ticker.appendChild(tickerClone);
        }

        let lastScrollY = window.scrollY;
        let currentTranslateX = 0;
        let ticking = false;

        const onScroll = () => {
          if (!isInViewport(section)) return;

          const scrollDelta = window.scrollY - lastScrollY;
          lastScrollY = window.scrollY;

          if (Math.abs(scrollDelta) === 0) return;

          let translateXValue = currentTranslateX - scrollDelta * 1;

          if (translateXValue > 0) {
            translateXValue = 0;
          }

          if (isRTL) {
            translateXValue = -translateXValue;
          }

          tickerBlock.style.transform = `translateX(${translateXValue}px)`;
          currentTranslateX = translateXValue;
        };

        window.addEventListener("scroll", () => {
          if (!tickerBlock) return;
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(() => {
              onScroll();
              ticking = false;
            });
          }
        });
      }

      // IMPORTANT: DO NOT control opacity here.
      // CSS now keeps hero visible by default for LCP.
      section.classList.add("hero_initialized");
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initHero();

    // For Shopify theme editor / dynamic section loads
    document.addEventListener("shopify:section:load", function () {
      initHero();
    });
  });
})();
